import { render, staticRenderFns } from "./Pillars.vue?vue&type=template&id=51ef7878&scoped=true"
import script from "./Pillars.js?vue&type=script&lang=js&external"
export * from "./Pillars.js?vue&type=script&lang=js&external"
import style0 from "./Pillars.scss?vue&type=style&index=0&id=51ef7878&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ef7878",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTitle: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Atoms/Title/Title.vue').default,HotContainer: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Templates/Container/Container.vue').default,HotImage: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Atoms/Image/Image.vue').default,HotCardJobs: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Molecules/CardJobs/CardJobs.vue').default})
